import './index.scss'

// When page is loaded
window.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.wrapper__burger').addEventListener('click', () => {
        document.querySelector('.wrapper__burger').classList.toggle('active')
        document.querySelector('.menu-main-menu-container').classList.toggle('active')
    })

    const links = document.querySelectorAll('.navmenu .menu-item a');
    links.forEach(link => {
        link.addEventListener('click', () => {
            document.querySelector('.wrapper__burger').classList.remove('active')
            document.querySelector('.menu-main-menu-container').classList.remove('active')
        })
    })


    // Apply the active class to the relevant menu item inside .menu-main-menu
    // when the user scrolls to it
    const menuItems = document.querySelectorAll('#menu-main-menu a')
    const sections = document.querySelectorAll('.section-title')

    let latestHighlighted = null

    const handleScroll = () => {
        sections.forEach((section, index) => {
            const top = section.getBoundingClientRect().top
            // Keep track of the last section that was highlighted, and let it stay highlighted until the next section is reached
            if(latestHighlighted) {
                latestHighlighted.classList.add('active')
            }
            if (top > 0 && top < window.innerHeight) {
                if (latestHighlighted !== index) {
                    latestHighlighted = menuItems[index]
                    menuItems.forEach((item) => {
                        item.classList.remove('active')
                    })
                    menuItems[index].classList.add('active')
                }
            } 


                
        })
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll();
})

